import { CookieLoader } from '@alme/storage-ts/CookieLoader';
import { getLogger } from '../../utils/DebugUtils';
import { gettopdomain } from '../../utils/UrlUtils';
export class AlmeAppUtilsBase {
    constructor(almeState, setAlmeState, appConfig) {
        this.almeState = almeState;
        this.setAlmeState = setAlmeState;
        this.appConfig = appConfig;
        this.logger = getLogger(appConfig.UiLogLevel);
    }
}
const savedAppState = new CookieLoader('almeUiState');
if (window.location.host.indexOf('localhost') === -1) {
    savedAppState.cookieOptions = { domain: gettopdomain() };
}
export function updateAppState(state) {
    const savedState = {
        isOpen: state.isOpen,
        lastEntryId: state.lastEntryId,
        isLoggedIn: state.isLoggedIn,
        clientSessionId: state.clientSessionId,
        sessionMessages: state.sessionMessages,
        customerCheckStatusMessage: state.customerCheckStatusMessage,
        sessionExpired: state.sessionExpired,
        lastActivityTime: state.lastActivityTime,
        sessionId: state.sessionId,
        cifId: state.cifId,
    };
    savedAppState.UpdateStorage(savedState);
}
export function clearStorage() {
    try {
        savedAppState.ClearStorage();
    }
    catch (ex) {
        console.error(ex);
    }
}
export function getCurrentAppState() {
    let appState = {
        isLoggedIn: false,
    };
    try {
        appState = savedAppState.GetStorage() || appState;
    }
    catch (ex) {
        console.error(ex);
    }
    return appState;
}
